import { redirect } from "@sveltejs/kit";
const GET = () => {
  throw redirect(302, "/releases/latest/glimmr-setup.exe");
};
export {
  GET
};
